"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("@trs/utils");
var _checkbox = _interopRequireDefault(require("../checkbox"));
var _ControlCard = _interopRequireDefault(require("./ControlCard.style"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ControlCard = function ControlCard(_ref) {
  var children = _ref.children,
    title = _ref.title,
    id = _ref.id,
    description = _ref.description,
    checked = _ref.checked,
    onChange = _ref.onChange,
    disabled = _ref.disabled,
    className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement(_ControlCard["default"], {
    checked: checked
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "control-card ".concat(className)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "control-card-checkbox"
  }, /*#__PURE__*/_react["default"].createElement(_checkbox["default"], {
    id: id,
    checked: checked,
    onChange: onChange,
    disabled: disabled
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "control-card-content"
  }, title && /*#__PURE__*/_react["default"].createElement("div", {
    className: "control-card-title"
  }, title), description && /*#__PURE__*/_react["default"].createElement("div", {
    className: "control-card-description"
  }, description))), checked && children);
};
ControlCard.propTypes = {
  className: _propTypes["default"].string,
  /** Text or html to be displayed inside the card */
  children: _propTypes["default"].node,
  /** A unique identifier for the control card */
  id: _propTypes["default"].string.isRequired,
  /** A text or html to be displayed as the card title */
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]).isRequired,
  /** A text or html to be displayed as the card content */
  description: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  /** Flag to control if to show/hide the children */
  checked: _propTypes["default"].bool,
  /** Action triggered on  */
  onChange: _propTypes["default"].func,
  /** Flag to enable or disable the checkbox  */
  disabled: _propTypes["default"].bool
};
ControlCard.defaultProps = {
  className: '',
  children: undefined,
  description: '',
  checked: false,
  onChange: _utils.noop,
  disabled: false
};
ControlCard.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ControlCard",
  "props": {
    "className": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "children": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Text or html to be displayed inside the card",
      "type": {
        "name": "node"
      },
      "required": false
    },
    "description": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "A text or html to be displayed as the card content",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "node"
        }]
      },
      "required": false
    },
    "checked": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Flag to control if to show/hide the children",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "onChange": {
      "defaultValue": {
        "value": "noop",
        "computed": true
      },
      "description": "Action triggered on",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Flag to enable or disable the checkbox",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "id": {
      "description": "A unique identifier for the control card",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "title": {
      "description": "A text or html to be displayed as the card title",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "node"
        }]
      },
      "required": true
    }
  }
};
var _default = ControlCard;
exports["default"] = _default;